@if (severity(); as severity) {
  <span class="severity-tag" [ngClass]="`severity-${severity.toLowerCase()}`">{{
    `model.finding.severity.${severity}` | translate
  }}</span>
}
